<template>
  <div id="ag-grid-demo">
    <menu-status-contrato></menu-status-contrato>
    <busca-contratos></busca-contratos>
    <paginacao-contratos></paginacao-contratos>
  </div>
</template>

<script>
import MenuStatusContrato from "./components/MenuStatusContrato";
import BuscaContratos from "./components/BuscaContratos";
import PaginacaoContratos from "./components/PaginacaoContratos";

export default {
  components: {
    MenuStatusContrato,
    BuscaContratos,
    PaginacaoContratos
  }
};
</script>

<style lang="scss"></style>
